import React from 'react';
import { User } from 'lucide-react';

const Author = () => {
  return (
    <section id="author" className="author-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">About the Author</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="author-content">
          <div className="author-image-wrapper">
            <div className="author-placeholder">
              <User size={120} />
            </div>
          </div>
          
          <div className="author-text">
            <h3 className="heading-3 author-name">Daniel A. Stoescu</h3>
            
            <div className="author-bio">
              <p className="body-medium">
                Daniel A. Stoescu is the author of <em>Mental and Emotional Health in Today's Hybrid Warfare Environment</em>. His work focuses on the intersection of psychology, conflict, misinformation, and individual resilience.
              </p>
              
              <p className="body-medium">
                Through this audiobook, Stoescu encourages listeners not only to protect themselves, but to become active participants in fostering truth and psychological well-being in society.
              </p>
              
              <p className="body-medium">
                His approach combines academic rigor with practical wisdom, offering tools that empower individuals to navigate the complexities of modern information warfare while maintaining their mental and emotional health.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Author;
